import { TableField } from 'lib/context';

export enum PronunciationsTableColumns {
  TEXT = 'text',
}

export enum PRONUNCIATIONS_SORT_KEYS {
  TEXT = 'TEXT',
}

export const tableFields: TableField[] = [
  {
    value: PronunciationsTableColumns.TEXT,
    label: 'Title',
    sortable: true,
    sortKey: PRONUNCIATIONS_SORT_KEYS.TEXT,
    width: 850,
  },
];
